export class PermisoMenuDto {
  menuCrearVlan: boolean;
  menuAsignacionManual: boolean;
  menuCrearSede: boolean;
  menuCrearVlanSede: boolean;
  menuAsignacionManualSede: boolean;
  menuAdministrarItems: boolean;
  menuCargueMasivo:boolean;
  permisoAsignacionIpAdminCeco:boolean;
  permisoAsignacionIpUsuario:boolean;

}



// WEBPACK FOOTER //
// ./src/app/shared/models/permiso-menu-dto.ts